<div
  class="viewer-compare-button-wrapper"
  ngbDropdown
  [class.is-fullscreen]="isFullscreen"
  placement="top"
  [container]="isFullscreen ? null : 'body'">
  <button
    type="button"
    class="viewer-controller-icon-btn compare-icon"
    [class.active]="isActive"
    aria-label="Compare"
    aria-haspopup="true"
    ngbDropdownToggle>
    <!-- Side by Side icon (default) -->
    @if ((currentCompareOption ?? compareOption) !== CompareOption.ABOVE_AND_BELOW) {
      <svg width="18" height="18" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g class="icon-g">
          <path
            d="M8.95971 12.9959H3.48041C1.95519 12.9959 0.71875 11.7595 0.71875 10.2343V6.31146C0.71875 4.78624 1.95518 3.5498 3.4804 3.5498H8.95971"
            stroke="currentColor"
            stroke-width="1.43315"
            stroke-linecap="round" />
          <path
            d="M12.2583 3.54999L12.793 3.54999C14.3183 3.54999 15.5547 4.78643 15.5547 6.31164L15.5547 10.2344C15.5547 11.7597 14.3183 12.9961 12.793 12.9961L12.2583 12.9961"
            stroke="currentColor"
            stroke-width="1.43315"
            stroke-linecap="round" />
          <path d="M8.96094 0.716797V15.8306" stroke="currentColor" stroke-width="1.43315" stroke-linecap="round" />
        </g>
      </svg>
    }
    <!-- Above & Below icon -->
    @if ((currentCompareOption ?? compareOption) === CompareOption.ABOVE_AND_BELOW) {
      <svg width="18" height="18" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g class="icon-g">
          <path
            d="M21.032 12.8762L21.032 15.8555C21.032 17.3808 19.7956 18.6172 18.2704 18.6172L6.34759 18.6172C4.82237 18.6172 3.58594 17.3808 3.58594 15.8555L3.58594 12.8762"
            stroke="currentColor"
            stroke-width="1.43315"
            stroke-linecap="round" />
          <path
            d="M0.75 9.88184L12.3069 9.88184L23.8638 9.88184"
            stroke="currentColor"
            stroke-width="1.43315"
            stroke-linecap="round" />
          <path
            d="M3.58515 7.12377L3.58515 4.14447C3.58515 2.61925 4.82158 1.38281 6.3468 1.38281L12.3082 1.38281L18.2696 1.38281C19.7948 1.38281 21.0312 2.61925 21.0312 4.14447L21.0312 7.12377"
            stroke="currentColor"
            stroke-width="1.43315"
            stroke-linecap="round" />
        </g>
      </svg>
    }
  </button>

  <div ngbDropdownMenu class="compare-dropdown-menu">
    <button
      type="button"
      ngbDropdownItem
      class="compare-option-item"
      (click)="selectOption(CompareOption.ABOVE_AND_BELOW)">
      <span class="compare-option-icon" aria-hidden="true">
        <svg width="24" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21.032 12.8762L21.032 15.8555C21.032 17.3808 19.7956 18.6172 18.2704 18.6172L6.34759 18.6172C4.82237 18.6172 3.58594 17.3808 3.58594 15.8555L3.58594 12.8762"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round" />
          <path
            d="M0.75 9.88184L12.3069 9.88184L23.8638 9.88184"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round" />
          <path
            d="M3.58515 7.12377L3.58515 4.14447C3.58515 2.61925 4.82158 1.38281 6.3468 1.38281L12.3082 1.38281L18.2696 1.38281C19.7948 1.38281 21.0312 2.61925 21.0312 4.14447L21.0312 7.12377"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round" />
        </svg>
      </span>
      <span class="compare-option-label">{{ 'assetComparer_aboveAndBelow' | translate }}</span>
    </button>
    <button
      type="button"
      ngbDropdownItem
      class="compare-option-item"
      (click)="selectOption(CompareOption.SIDE_BY_SIDE)">
      <span class="compare-option-icon" aria-hidden="true">
        <svg width="24" height="20" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.90409 18.8366H3.51165C1.98644 18.8366 0.75 17.6002 0.75 16.0749L0.75 8.29388C0.75 6.76866 1.98643 5.53223 3.51165 5.53223H8.90409"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round" />
          <path d="M11.8672 0.750488V12.1855V23.6206" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <path
            d="M14.5959 5.5345L19.9883 5.5345C21.5136 5.5345 22.75 6.77094 22.75 8.29616L22.75 16.0772C22.75 17.6024 21.5136 18.8389 19.9883 18.8389L14.5959 18.8389"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round" />
        </svg>
      </span>
      <span class="compare-option-label">{{ 'assetComparer_sideBySide' | translate }}</span>
    </button>
    @if (isCompareMode) {
      <button type="button" ngbDropdownItem class="compare-option-item" (click)="selectOption(CompareOption.QUIT)">
        <span class="compare-option-icon" aria-hidden="true">
          <svg width="24" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.6562 4.34326L4.34254 15.657" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            <path
              d="M15.6562 15.6572L4.34254 4.34352"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round" />
          </svg>
        </span>
        <span class="compare-option-label">{{ 'assetComparer_leaveComparison' | translate }}</span>
      </button>
    }
  </div>
</div>
